import { DefaultTheme } from 'styled-components'

export type SocialButtonColorVariant = 'colored' | 'ghost' | 'grey'
type SocialButtonItemProps = {
  default: string
  hover: string
  active?: string
  darkModeDefault?: string
  darkModeHover?: string
}
export type SocialButtonItemType = {
  icon: SocialButtonItemProps
  border?: SocialButtonItemProps
  background?: SocialButtonItemProps
}

const getSocialButtonVariantsMap = (
  themeColor: DefaultTheme['colors'],
): Record<SocialButtonColorVariant, SocialButtonItemType> => ({
  ghost: {
    border: {
      default: themeColor.strokeStrong,
      hover: themeColor.strokeStrongHover,
      active: themeColor.strokeBrand,
      darkModeDefault: themeColor.staticWhite,
      darkModeHover: themeColor.staticNeutral200,
    },
    icon: {
      default: themeColor.iconDefault,
      hover: themeColor.iconDefault,
      active: themeColor.iconBrand,
      darkModeDefault: themeColor.staticWhite,
    },
  },
  grey: {
    background: {
      default: themeColor.fillStrong,
      hover: themeColor.fillStrongHover,
      active: themeColor.fillBrand,
      darkModeDefault: themeColor.staticNeutral800,
      darkModeHover: themeColor.staticNeutral700,
    },
    icon: {
      default: themeColor.iconDefault,
      hover: themeColor.iconDefault,
      darkModeDefault: themeColor.staticWhite,
    },
  },
  colored: {
    background: {
      default: themeColor.fillInverse,
      hover: themeColor.fillInverseHover,
      active: themeColor.fillBrand,
      darkModeDefault: themeColor.staticWhite,
      darkModeHover: themeColor.staticNeutral200,
    },
    icon: {
      default: themeColor.iconInverse,
      hover: themeColor.iconInverse,
      darkModeDefault: themeColor.staticBlack,
    },
  },
})

export { getSocialButtonVariantsMap }
